import React from 'react';
import { toast } from 'react-toastify';
import { call, put, takeLatest } from 'redux-saga/effects';
import { authService } from './client.service';
import {
    GET_AUTH_UTILIZATION,
    GET_AUTH_UTILIZATION_SUCCESS,
    CREATE_CLIENT,
    DELETE_CLIENT,
    EDIT_CLIENT,
    GET_CLIENT_BY_ID,
    GET_CLIENT_BY_ID_SUCCESS,
    GET_CLIENT_CONTACTS,
    GET_CLIENT_CONTACTS_SUCCESS,
    GET_CLIENT_ENROLLMENT,
    GET_CLIENT_ENROLLMENT_SUCCESS,
    GET_CLIENTS,
    GET_CLIENTS_SUCCESS,
    CREATE_CLIENT_CONTACT,
    EDIT_CLIENT_CONTACT,
    DELETE_CLIENT_CONTACT,
    CREATE_CLIENT_ENROLLMENT,
    EDIT_CLIENT_ENROLLMENT,
    DELETE_CLIENT_ENROLLMENT,
    EDIT_CLIENT_AUTHORIZATION,
    CREATE_CLIENT_CONTACT_SUCCESS,
    ADD_FILES_TO_CLIENT_AUTH,
    REMOVE_FILES_FROM_CLIENT_AUTH,
    TERMINATE_CLIENT_ENROLLMENT,
    EDIT_FILE_NAME_OF_CLIENT_AUTH,
    CHANGE_ENROLLMENT_TYPE,
    ADD_CLIENT_ADDRESS,
    EDIT_CLIENT_ADDRESS,
    DELETE_CLIENT_ADDRESS,
    GET_CLIENT_SCHEDULING_ADDRESS,
    GET_CLIENT_SCHEDULING_ADDRESS_SUCCESS,
    SET_CLIENT_SCHEDULING_ADDRESS,
    CLEAR_CLIENT_SCHEDULING_ADDRESS,
    ASSIGN_STAFF,
    GET_ASSIGNED_STAFFS,
    GET_ASSIGNED_STAFFS_SUCCESS,
    REMOVE_STAFF,
    EDIT_CLIENT_STATUS,
    EDIT_ASSIGNED_STAFF,
    GET_BASIC_CLIENTS,
    GET_BASIC_CLIENTS_SUCCESS,
    GET_BASIC_ACTIVE_CLIENTS,
    GET_BASIC_ACTIVE_CLIENTS_SUCCESS,
    ADD_CLIENT_AUTHORIZATION,
    GET_CLIENT_AUTHORIZATIONS,
    GET_CLIENT_AUTHORIZATIONS_SUCCESS,
    INACTIVATE_CLIENT_AUTHORIZATION,
    CANCEL_CLIENT_AUTHORIZATION,
    DELETE_CLIENT_AUTHORIZATION,
    DELETE_AUTHORIZED_SERVICE,
    CLIENT_AUTHORIZATION_VISIBLE,
    GITE_CLIENT_AUTH_FILES,
    GITE_CLIENT_AUTH_FILES_SUCCESS,
    GET_AUTH_UNIT_INFO_SUCCESS,
    GET_AUTH_UNIT_INFO,
    GET_CLIENT_AUTHORIZATIONS_APPT,
    GET_CLIENT_AUTHORIZATIONS_APPT_SUCCESS,
    GET_ENROLLMENT_PAYERS,
    GET_ENROLLMENT_PAYERS_SUCCESS,
    RESEND_CLIENT_INVITE,
    GET_CLIENT_FORMS,
    GET_CLIENT_FORMS_SUCCESS,
    DELETE_CLIENT_FORM,
    ADD_CLIENT_FORM,
    GET_CLIENT_CONTACTS_INFO,
    GET_CLIENT_CONTACTS_INFO_SUCCESS,
    CREATE_CLIENT_INTAKE_FORM,
    LINK_CONTACT_TO_CLIENT,
    GRANT_PORTAL_ACCESS,
    REVOKE_PORTAL_ACCESS,
    SET_CLIENT_CONTACT_PASSWORD,
    GET_CLIENT_SECTIONS,
    GET_CLIENT_SECTIONS_SUCCESS,
    CREATE_CLIENT_SECTION,
    EDIT_CLIENT_SECTION,
    DELETE_CLIENT_SECTION,
    GET_CLIENTS_EXPIRATION,
    GET_CLIENTS_EXPIRATION_SUCCESS,
    GET_CLIENT_ALL_NOTES,
    GET_CLIENT_ALL_NOTES_SUCCESS,
    DELETE_CLIENT_NOTES,
} from './client.types';
import { httpRequestsOnErrorsActions } from '../http_requests_on_errors';
import { httpRequestsOnLoadActions } from '../http_requests_on_load';
import { httpRequestsOnSuccessActions } from '../http_requests_on_success';
import { NotError } from 'components';

function* getClients(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientsService, action.payload);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLIENTS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}
function* getClientExpiration(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientExpirationService, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLIENTS_EXPIRATION_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getBasicClients(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(authService.getBasicClientsService, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_BASIC_CLIENTS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getBasicActiveClients(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(authService.getBasicClientsService, { ...action?.payload?.params, status: 'ACTIVE' });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_BASIC_ACTIVE_CLIENTS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* createClient(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.createClientService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* createIntakeForm(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.createIntakeFormService, action?.payload?.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* resendClientInvite(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.resendClientInviteService, action?.payload?.id, action?.payload?.params);
        const res = yield call(authService.getClientByIdService, action);
        yield put({
            type: GET_CLIENT_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClient(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteClientService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put({
            type: GET_CLIENTS,
            payload: { status: 1, start: 0, end: 10 },
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClient(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editClientService, action);
        const res = yield call(authService.getClientByIdService, action);
        yield put({
            type: GET_CLIENT_BY_ID_SUCCESS,
            payload: res.data,
        });

        // yield put({
        //     type: GET_CLIENT_BY_ID,
        //     payload: { id: action?.payload?.id, load: 'noload' },
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClientById(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action.payload.load !== 'noload') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(authService.getClientByIdService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLIENT_BY_ID_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getClientContacts(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        // const res = yield call(authService.getClientContactsWithPortalService, action?.payload?.id, action?.payload?.data);
        const res = yield call(authService.getClientContactsService, action?.payload?.id, action?.payload?.data);
        yield put({
            type: GET_CLIENT_CONTACTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}
function* getClientContactInfo(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientContactInfoService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLIENT_CONTACTS_INFO_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* createClientContact(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(authService.createClientContactService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put({
            type: CREATE_CLIENT_CONTACT_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClientContact(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editClientContactService, action);
        const res = yield call(authService.getClientContactsService, action?.payload?.paramsId);
        yield put({
            type: GET_CLIENT_CONTACTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClientContact(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteClientContactService, action);

        const res = yield call(authService.getClientContactsService, action?.payload?.paramsId);
        yield put({
            type: GET_CLIENT_CONTACTS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClientStatus(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.setClientStatus, action?.payload?.id, action?.payload?.status);
        yield put(httpRequestsOnSuccessActions.appendSuccess(action?.type));
        const res = yield call(authService.getClientByIdService, action);
        yield put({
            type: GET_CLIENT_BY_ID_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Client Enrollment */

function* getClientEnrollment(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientEnrollmentService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLIENT_ENROLLMENT_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getEnrollmentPayers(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getEnrollmentPayersService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_ENROLLMENT_PAYERS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* createClientEnrollment(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.createClientEnrollmentService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClientEnrollment(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editClientEnrollmentService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* terminateClientEnrollment(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.terminateClientEnrollmentService, action?.payload?.enrollmentId, action?.payload?.body);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClientEnrollment(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(authService.deleteClientEnrollmentService, action);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put({
            type: GET_CLIENT_ENROLLMENT,
            payload: { id: action.payload.clientId },
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* changeEnrollmentType(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.changeEnrollmentTypeService, action?.payload);
        yield put({
            type: GET_CLIENT_ENROLLMENT,
            payload: { id: action.payload.clientId },
        });
        yield put({
            type: GET_CLIENT_AUTHORIZATION,
            payload: { id: action?.payload?.clientId },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

function* getClientAuthFiles(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(authService.getClientAuthFilesService, action?.payload?.clientId, action?.payload?.params);
        yield put({
            type: GITE_CLIENT_AUTH_FILES_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* addFilesToClientAuth(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.addFilesToClientAuthService, action?.payload);
        const res = yield call(authService.getClientAuthFilesService, action?.payload?.clientId, action?.payload?.params);
        yield put({
            type: GITE_CLIENT_AUTH_FILES_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* removeFilesFromClientAuth(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.removeFilesFromClientAuthService, action.payload);
        const res = yield call(authService.getClientAuthFilesService, action?.payload?.clientId, action?.payload?.params);
        yield put({
            type: GITE_CLIENT_AUTH_FILES_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editFileNameOfClientAuth(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            authService.editFileNameOfClientAuthService,
            action?.payload
            // action?.payload?.params, action?.payload?.docId, action?.payload?.fileName
        );
        const res = yield call(authService.getClientAuthFilesService, action?.payload?.clientId, action?.payload?.params);
        yield put({
            type: GITE_CLIENT_AUTH_FILES_SUCCESS,
            payload: res?.data,
        });
        // const response = yield call(authService.getClientAuthorizationService, res.data?.clientId);
        // yield put({
        //     type: GET_CLIENT_AUTHORIZATION_SUCCESS,
        //     payload: response?.data,
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Staff Documents */

function* addClientAddress(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.addClientAddressService, action.payload);
        yield put({
            type: GET_CLIENT_BY_ID,
            payload: { id: action?.payload?.id, load: 'noload' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClientAddress(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editClientAddressService, action?.payload);
        yield put({
            type: GET_CLIENT_BY_ID,
            payload: { id: action?.payload?.id, load: 'noload' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClientAddress(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteClientAddressService, action.payload);
        yield put({
            type: GET_CLIENT_BY_ID,
            payload: { id: action?.payload?.id, load: 'noload' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnSuccessActions.removeSuccess('MINI_LOAD'));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess('MINI_LOAD'));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Client Scheduling Address */

function* getClientSchedulingAddress(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientSchedulingAddressService, action.payload);
        yield put({
            type: GET_CLIENT_SCHEDULING_ADDRESS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* setClientSchedulingAddress(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.setClientSchedulingAddressService, action.payload);
        yield put({ type: GET_CLIENT_SCHEDULING_ADDRESS, payload: { id: action?.payload?.id } });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* clearClientSchedulingAddress(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.clearClientSchedulingAddressService, action.payload);
        yield put({ type: GET_CLIENT_SCHEDULING_ADDRESS, payload: { id: action?.payload?.id } });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

function* assignStaff(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.assignStaffService, action.payload?.body);
        yield put({
            type: GET_ASSIGNED_STAFFS,
            payload: { id: action?.payload?.body?.clientId, load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editAssignedStaff(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editAssignedStaffService, action?.payload?.id, action.payload?.body);
        yield put({
            type: GET_ASSIGNED_STAFFS,
            payload: { id: action?.payload?.clientId, load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getAssignedStaff(action) {
    if (action.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(authService.getAssignedStaffService, action.payload?.id);
        yield put({
            type: GET_ASSIGNED_STAFFS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* removeClientStaff(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.removeClientStaffService, action?.payload?.staffId);
        yield put({
            type: GET_ASSIGNED_STAFFS,
            payload: { id: action?.payload?.clientId, load: 'noLoad' },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* addClientAuthorization(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.addClientAuthorizationService, action?.payload?.id, action?.payload?.body);
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.id);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClientAuthorization(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editClientAuthorizationService, action?.payload?.clientId, action?.payload?.body);
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* inactivateClientAuthorization(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.inactivateClientAuthorizationService, action?.payload?.id, action?.payload?.reason);
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* cancelClientAuthorization(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.cancelClientAuthorizationService, action?.payload?.clientId, {
            authorizationUniqueId: action?.payload?.authorizationUniqueId,
            payerId: action?.payload?.payerId,
            reason: action?.payload?.reason,
        });
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClientAuthorization(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteClientAuthorizationService, action?.payload?.clientId, {
            authorizationUniqueId: action?.payload?.authorizationUniqueId,
            payerId: action?.payload?.payerId,
        });
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteAuthorizedService(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteAuthorizedServiceService, action?.payload?.id);
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* clientAuthorizationVisible(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.clientAuthorizationVisible, action?.payload?.id, action?.payload?.isApptVisible);
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClientAuthorization(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(authService.getClientAuthorizationsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClientAuthorizationAppt(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(
            authService.getClientAuthorizationApptService,
            action?.payload?.clientId,
            action?.payload?.reqType,
            action?.payload?.showExpired
        );
        yield put({
            type: GET_CLIENT_AUTHORIZATIONS_APPT_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClientsAuthorizationAppt(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientsAuthorizationApptService, action?.payload?.authId, action?.payload?.status);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_AUTH_UNIT_INFO_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Forms */
function* getClientForms(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientFormsService, action?.payload?.clientId, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLIENT_FORMS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* deleteClientForms(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteClientFormsService, action?.payload?.clientId, action?.payload?.formId);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* addClientForms(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.addClientFormsService, action?.payload?.clientId, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Link Contact */
function* linkContactToClient(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(
            authService.linkContactToClientService,
            action?.payload?.contactId,
            action?.payload?.clientId,
            action?.payload?.grantPortalAccess
        );
        yield put({
            type: GET_CLIENT_CONTACTS,
            payload: { id: action?.payload?.clientId },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** Portal Access */
function* grantPortalAccess(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.grantPortalAccessService, action?.payload?.clientId, action?.payload?.contactId);

        // const res = yield call(authService.getClientContactsWithPortalService, action?.payload?.clientId);
        const res = yield call(authService.getClientContactsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_CONTACTS_SUCCESS,
            payload: res.data,
        });

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* revokePortalAccess(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.revokePortalAccessService, action?.payload?.clientId, action?.payload?.contactId);

        const res = yield call(authService.getClientContactsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_CONTACTS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* setClientContactPassword(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.setClientContactPasswordService, action?.payload?.id, action?.payload?.body);

        if (action?.payload?.clientId) {
            const res = yield call(authService.getClientContactsService, action?.payload?.clientId);
            yield put({
                type: GET_CLIENT_CONTACTS_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
/** End */

/** Client Sections */

function* getClientSections(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientSectionsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_SECTIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* createClientSection(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.createClientSectionService, action?.payload?.clientId, action?.payload?.body);
        const res = yield call(authService.getClientSectionsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_SECTIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClientSection(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.editClientSectionService, action?.payload?.clientId, action?.payload?.sectionId, action?.payload?.body);
        const res = yield call(authService.getClientSectionsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_SECTIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClientSection(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(authService.deleteClientSectionService, action?.payload?.clientId, action?.payload?.sectionId);
        const res = yield call(authService.getClientSectionsService, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_SECTIONS_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** Client Documentation Notes */

function* getClientAllNotesSaga(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const res = yield call(authService.getClientAllNotesService, action?.payload?.params, action?.payload?.clientId);
        yield put({
            type: GET_CLIENT_ALL_NOTES_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClientAllNotesSaga(action) {
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(authService.deleteClientAllNotesSagaService, action?.payload?.docId);

        if (action?.payload?.requestParams) {
            const res = yield call(authService.getClientAllNotesService, action?.payload?.requestParams, action?.payload?.clientId);
            yield put({
                type: GET_CLIENT_ALL_NOTES_SUCCESS,
                payload: res.data,
            });
        }
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

/** takeLatest: a new filter/range request cancels a page still in flight, so stale pages never land. */
function* getAuthUtilization(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        const params = action?.payload?.params;
        const res = yield call(authService.getAuthUtilizationService, params);
        yield put({
            type: GET_AUTH_UTILIZATION_SUCCESS,
            payload: { data: res?.data, append: !!params?.skip },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        if (!action?.payload?.params?.skip) {
            yield put({ type: GET_AUTH_UTILIZATION_SUCCESS, payload: { data: { clients: [], count: 0 }, append: false } });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

export const watchClient = function* watchClientSaga() {
    yield takeLatest(GET_AUTH_UTILIZATION, getAuthUtilization);
    yield takeLatest(GET_CLIENTS, getClients);
    yield takeLatest(GET_CLIENTS_EXPIRATION, getClientExpiration);
    yield takeLatest(GET_BASIC_CLIENTS, getBasicClients);
    yield takeLatest(GET_BASIC_ACTIVE_CLIENTS, getBasicActiveClients);
    yield takeLatest(CREATE_CLIENT, createClient);
    yield takeLatest(CREATE_CLIENT_INTAKE_FORM, createIntakeForm);
    yield takeLatest(RESEND_CLIENT_INVITE, resendClientInvite);
    yield takeLatest(DELETE_CLIENT, deleteClient);
    yield takeLatest(EDIT_CLIENT, editClient);
    yield takeLatest(GET_CLIENT_BY_ID, getClientById);
    yield takeLatest(GET_CLIENT_CONTACTS, getClientContacts);
    yield takeLatest(GET_CLIENT_CONTACTS_INFO, getClientContactInfo);
    yield takeLatest(CREATE_CLIENT_CONTACT, createClientContact);
    yield takeLatest(EDIT_CLIENT_CONTACT, editClientContact);
    yield takeLatest(DELETE_CLIENT_CONTACT, deleteClientContact);
    yield takeLatest(EDIT_CLIENT_STATUS, editClientStatus);

    /** Client Enrollment */
    yield takeLatest(GET_ENROLLMENT_PAYERS, getEnrollmentPayers);
    yield takeLatest(GET_CLIENT_ENROLLMENT, getClientEnrollment);
    yield takeLatest(CREATE_CLIENT_ENROLLMENT, createClientEnrollment);
    yield takeLatest(EDIT_CLIENT_ENROLLMENT, editClientEnrollment);
    yield takeLatest(TERMINATE_CLIENT_ENROLLMENT, terminateClientEnrollment);
    yield takeLatest(DELETE_CLIENT_ENROLLMENT, deleteClientEnrollment);
    yield takeLatest(CHANGE_ENROLLMENT_TYPE, changeEnrollmentType);
    /** End */

    /** Client Address */
    yield takeLatest(ADD_CLIENT_ADDRESS, addClientAddress);
    yield takeLatest(EDIT_CLIENT_ADDRESS, editClientAddress);
    yield takeLatest(DELETE_CLIENT_ADDRESS, deleteClientAddress);
    /** End */

    /** Client Scheduling Address */
    yield takeLatest(GET_CLIENT_SCHEDULING_ADDRESS, getClientSchedulingAddress);
    yield takeLatest(SET_CLIENT_SCHEDULING_ADDRESS, setClientSchedulingAddress);
    yield takeLatest(CLEAR_CLIENT_SCHEDULING_ADDRESS, clearClientSchedulingAddress);
    /** End */

    /** Client Assignment */
    yield takeLatest(ASSIGN_STAFF, assignStaff);
    yield takeLatest(EDIT_ASSIGNED_STAFF, editAssignedStaff);
    yield takeLatest(GET_ASSIGNED_STAFFS, getAssignedStaff);
    yield takeLatest(REMOVE_STAFF, removeClientStaff);
    /** End */

    /** Client Authorization */
    yield takeLatest(ADD_CLIENT_AUTHORIZATION, addClientAuthorization);
    yield takeLatest(EDIT_CLIENT_AUTHORIZATION, editClientAuthorization);
    yield takeLatest(INACTIVATE_CLIENT_AUTHORIZATION, inactivateClientAuthorization);
    yield takeLatest(CANCEL_CLIENT_AUTHORIZATION, cancelClientAuthorization);
    yield takeLatest(DELETE_CLIENT_AUTHORIZATION, deleteClientAuthorization);
    yield takeLatest(DELETE_AUTHORIZED_SERVICE, deleteAuthorizedService);
    yield takeLatest(CLIENT_AUTHORIZATION_VISIBLE, clientAuthorizationVisible);
    yield takeLatest(GET_CLIENT_AUTHORIZATIONS, getClientAuthorization);
    yield takeLatest(GET_CLIENT_AUTHORIZATIONS_APPT, getClientAuthorizationAppt);
    yield takeLatest(GITE_CLIENT_AUTH_FILES, getClientAuthFiles);
    yield takeLatest(ADD_FILES_TO_CLIENT_AUTH, addFilesToClientAuth);
    yield takeLatest(REMOVE_FILES_FROM_CLIENT_AUTH, removeFilesFromClientAuth);
    yield takeLatest(EDIT_FILE_NAME_OF_CLIENT_AUTH, editFileNameOfClientAuth);
    yield takeLatest(GET_AUTH_UNIT_INFO, getClientsAuthorizationAppt);
    /** End */

    /** Client Forms */
    yield takeLatest(GET_CLIENT_FORMS, getClientForms);
    yield takeLatest(DELETE_CLIENT_FORM, deleteClientForms);
    yield takeLatest(ADD_CLIENT_FORM, addClientForms);
    /** End */

    /** Link Contact */
    yield takeLatest(LINK_CONTACT_TO_CLIENT, linkContactToClient);
    /** End */

    /** Portal Access */
    yield takeLatest(GRANT_PORTAL_ACCESS, grantPortalAccess);
    yield takeLatest(REVOKE_PORTAL_ACCESS, revokePortalAccess);
    yield takeLatest(SET_CLIENT_CONTACT_PASSWORD, setClientContactPassword);
    /** End */

    /** Client Sections */
    yield takeLatest(GET_CLIENT_SECTIONS, getClientSections);
    yield takeLatest(CREATE_CLIENT_SECTION, createClientSection);
    yield takeLatest(EDIT_CLIENT_SECTION, editClientSection);
    yield takeLatest(DELETE_CLIENT_SECTION, deleteClientSection);
    /** End */

    /** Client Documentation Notes */
    yield takeLatest(GET_CLIENT_ALL_NOTES, getClientAllNotesSaga);
    yield takeLatest(DELETE_CLIENT_NOTES, deleteClientAllNotesSaga);
    /** End */
};
